import { RelatedArticles } from "@/types"

export const sortArticlesByNewest = (articles: RelatedArticles[] | undefined) => {
    return articles?.sort(
        (a, b) =>
            new Date(b.articleCreationDate ?? b._createdAt).getTime() -
            new Date(a.articleCreationDate ?? a._createdAt).getTime()
    )
}
